/**
 * <Dock />
 *
 * a customized Dock. A facade for react-dock
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import Dock from 'react-dock';
import classnames from 'classnames'
import { connect } from 'react-redux';
import './Dock.scss';
import keydown, { ALL_KEYS } from 'react-keydown';
import { browserHistory } from 'react-router';
import ARROW_RIGHT from 'icons/arrow_right.svg';

const DEFAULT_POSITON = 'right';

const OPEN_DELAY = 50;

const Z_INDEX = 500;

const mapStateToProps = state => ({
});

//
// we're going to detect the key press with our Redux state 'Shortcut'
//
class CustomDock extends React.Component {
  static propTypes = {
    useDefaultCloseButton: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    allowEscKeyToClose: true,
  }

  constructor(props) {
    super(props);
		this.closeDock = this.closeDock.bind(this);
    this.listenToKeys = this.listenToKeys.bind(this);
    this.state = {
      isVisible: false,
    }
    this.setActionsWhenRouteChanges(props);
  }

  setActionsWhenRouteChanges(props) {
    browserHistory.listen((location)=> {
     if (typeof props.onCloseModalClick === 'function') {
       props.onCloseModalClick();
     }
    }); 
  }

  componentWillMount() {
		let {
			isVisible,
		} = this.props

    setTimeout(()=>{
      this.setState({
        isVisible,
      });
    }, OPEN_DELAY);
  }

  @keydown(ALL_KEYS)
  listenToKeys(e) {

    let {
      allowEscKeyToClose,
      onCloseDockClick,
    } = this.props;

    // 
    // When used with confirmable, just make the invisible is not good enough
    // you need to actually dissmiss() it which is doneby onCloseDockClick()
    //
    if (allowEscKeyToClose) {
      if (e.code === 'Escape') {
        onCloseDockClick();
      }
    }
  }

  componentWillReceiveProps({isVisible}) {
    if (isVisible === false) {
      this.setState({
        isVisible: false,
      });
    }
  }

  closeDock() {
		let {
			onCloseDockClick
		} = this.props;

		if (typeof onCloseDockClick == "function") {
			onCloseDockClick();
    } else {
      this.setState({
        isVisible: false,
      });
    }
	}

  render() {
    const {
      position,
      defaultSize,
      useDefaultCloseButton,
      Shortcut,
      children,
      dockTitle,
      dockStyle,
      dockIcon,
      className,
      useClosingTag,
      overlayOpacity = 0.2,
    } = this.props;

    const {
      isVisible,
    } = this.state;

    const notResizable = !defaultSize;

    return (
      <div className={classnames('classtop-custom-dock', className, { notResizable })} style={{zIndex: Z_INDEX}}>
        <Dock 
          {...this.props} 
          zindex={Z_INDEX} 
          position={position || DEFAULT_POSITION} 
          isVisible={isVisible} 
          onVisibleChange={this.closeDock}
          dimStyle={{opacity: overlayOpacity}}
          dockStyle={{ 'boxShadow': '-10px 0 30px rgba(25,25,25,0.1)', ...dockStyle, }}
        >
          { useDefaultCloseButton != false && (
            <div className='close-button' onClick={this.closeDock}>
              <i className='fa icon-cancel'></i>
            </div>
            )
          }
          { dockTitle !== undefined &&
            <div className='dock-header'>
              { dockIcon !== undefined && <i className={dockIcon}></i>}
              <h4>{ dockTitle }</h4>
            </div>
          }
          { useClosingTag && 
            <div className='closingTag' onClick={this.closeDock}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" enableBackground="new 0 0 100 100"><path d="M29.56,97.137C28.984,97.714,28.229,98,27.475,98s-1.51-0.286-2.085-0.863c-1.152-1.152-1.152-3.018,0-4.169L68.356,50  L25.39,7.031c-1.152-1.149-1.152-3.015,0-4.169c1.152-1.15,3.018-1.15,4.17,0L74.61,47.917c1.152,1.15,1.152,3.015,0,4.17  L29.56,97.137z"/></svg>
            </div>
          }
          <div className='dock-body'>  
            { children }
          </div>
        </Dock>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CustomDock);



// WEBPACK FOOTER //
// ./src/components/UI/Dock/index.js